import { Typography } from "@mui/material";

function Header() {
  return (
    <header className="header">
      <Typography variant="h4">Title</Typography>
    </header>
  );
}
export default Header;
